import React, { Component } from 'react';
import { withRouter } from 'react-router-dom/cjs/react-router-dom.min';
import CompanyAgreementService from '../services/CompanyAgreementService';
import AppPrefixUtils from '../utils/AppPrefixUtils';

class CompanyAgreementBanner extends Component {
    constructor(props) {
        super(props);
        this.companyAgreementService = new CompanyAgreementService();
        this.state = {
            hasNotAcceptedAgreements: false,
            loading: true,
        };
    }

    componentDidMount() {
        // Sprawdź czy mamy zapisany status w sessionStorage
        const savedStatus = sessionStorage.getItem('company-agreement-status');
        if (savedStatus) {
            try {
                const status = JSON.parse(savedStatus);
                const hasNotAcceptedAgreements = !status.allAgreementsAccepted || 
                    (status.notAcceptedAgreementIds && status.notAcceptedAgreementIds.length > 0) ||
                    (status.notAcceptedAgreements && status.notAcceptedAgreements.length > 0);
                
                this.setState({ 
                    hasNotAcceptedAgreements,
                    loading: false 
                });
            } catch (e) {
                // Jeśli nie można sparsować, sprawdź ponownie
                this.checkAgreementStatus();
            }
        } else {
            // Jeśli nie ma zapisanego statusu, sprawdź teraz
            this.checkAgreementStatus();
        }
        
        // Nasłuchuj zmian w sessionStorage (gdy zgoda zostanie zaakceptowana na innej stronie)
        window.addEventListener('storage', this.handleStorageChange);
        // Nasłuchuj również custom event (dla zmian w tej samej karcie)
        window.addEventListener('company-agreement-status-updated', this.handleStatusUpdate);
    }

    componentWillUnmount() {
        window.removeEventListener('storage', this.handleStorageChange);
        window.removeEventListener('company-agreement-status-updated', this.handleStatusUpdate);
    }

    handleStorageChange = (e) => {
        if (e.key === 'company-agreement-status') {
            this.updateStatusFromStorage();
        }
    };

    handleStatusUpdate = () => {
        this.updateStatusFromStorage();
    };

    updateStatusFromStorage = () => {
        const savedStatus = sessionStorage.getItem('company-agreement-status');
        if (savedStatus) {
            try {
                const status = JSON.parse(savedStatus);
                const hasNotAcceptedAgreements = !status.allAgreementsAccepted || 
                    (status.notAcceptedAgreementIds && status.notAcceptedAgreementIds.length > 0) ||
                    (status.notAcceptedAgreements && status.notAcceptedAgreements.length > 0);
                
                this.setState({ 
                    hasNotAcceptedAgreements,
                    loading: false 
                });
            } catch (e) {
                // Ignoruj błędy parsowania
            }
        }
    };

    checkAgreementStatus = () => {
        this.companyAgreementService
            .getStatus()
            .then((status) => {
                // Zapisz status w sessionStorage
                sessionStorage.setItem('company-agreement-status', JSON.stringify(status));
                
                const hasNotAcceptedAgreements = !status.allAgreementsAccepted || 
                    (status.notAcceptedAgreementIds && status.notAcceptedAgreementIds.length > 0) ||
                    (status.notAcceptedAgreements && status.notAcceptedAgreements.length > 0);
                
                this.setState({ 
                    hasNotAcceptedAgreements,
                    loading: false 
                });
            })
            .catch(() => {
                this.setState({ loading: false });
            });
    };

    handleGoToAgreements = () => {
        sessionStorage.setItem('tab-company-index', '3');
        this.props.history.push(AppPrefixUtils.locationHrefUrl('/company/details'));
    };

    render() {
        const { hasNotAcceptedAgreements, loading } = this.state;

        if (loading || !hasNotAcceptedAgreements) {
            return null;
        }

        return (
            <div style={{ 
                marginBottom: '20px',
                marginTop: '10px',
                animation: 'slideDown 0.3s ease-out'
            }}>
                <div style={{
                    width: '100%',
                    borderRadius: '8px',
                    border: '2px solid #ff9800',
                    backgroundColor: '#fff3cd',
                    padding: '16px 20px',
                    boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    flexWrap: 'wrap',
                    gap: '15px'
                }}>
                    <div style={{ 
                        display: 'flex', 
                        alignItems: 'center', 
                        gap: '12px',
                        flex: 1,
                        minWidth: '250px'
                    }}>
                        <i className="pi pi-exclamation-triangle" style={{ 
                            fontSize: '24px', 
                            color: '#ff9800',
                            flexShrink: 0
                        }}></i>
                        <div>
                            <strong style={{ 
                                fontSize: '16px', 
                                color: '#856404',
                                display: 'block',
                                marginBottom: '4px'
                            }}>
                                Niezaakceptowane zgody
                            </strong>
                            <span style={{ 
                                fontSize: '14px', 
                                color: '#856404',
                                display: 'block'
                            }}>
                                Istnieją niezaakceptowane zgody wymagane dla Twojej firmy. 
                                Proszę przejść do sekcji zgód, aby je zaakceptować.
                            </span>
                        </div>
                    </div>
                    <button
                        onClick={this.handleGoToAgreements}
                        style={{
                            backgroundColor: '#ff9800',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '10px 24px',
                            fontSize: '14px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                            flexShrink: 0
                        }}
                        onMouseOver={(e) => {
                            e.target.style.backgroundColor = '#f57c00';
                            e.target.style.transform = 'translateY(-1px)';
                            e.target.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.3)';
                        }}
                        onMouseOut={(e) => {
                            e.target.style.backgroundColor = '#ff9800';
                            e.target.style.transform = 'translateY(0)';
                            e.target.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.2)';
                        }}
                    >
                        <i className="pi pi-arrow-right" style={{ marginRight: '8px' }}></i>
                        Przejdź do zgód
                    </button>
                </div>
                <style>{`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                        }
                    }
                `}</style>
            </div>
        );
    }
}

export default withRouter(CompanyAgreementBanner);

